import { IconSizes as e } from "./novoui-vuejs53.js";
import { ESpinnerColors as n } from "./novoui-vuejs43.js";
var m = /* @__PURE__ */ ((t) => (t.fill = "fill", t.outline = "outline", t.text = "text", t.outlineSubtle = "outlineSubtle", t.destructive = "destructive", t))(m || {}), o = /* @__PURE__ */ ((t) => (t.xs = "xs", t.tiny = "tiny", t.small = "small", t.sm = "sm", t.md = "md", t.medium = "medium", t.lg = "lg", t.large = "large", t))(o || {});
const d = (t) => {
  switch (t) {
    case "fill":
      return "";
    case "outline":
      return "button-outline";
    case "text":
      return "button-text";
    case "outlineSubtle":
      return "button-outline-subtle";
    case "destructive":
      return "button-destructive";
    default:
      return "";
  }
}, b = (t) => {
  switch (t) {
    case "xs":
    case "tiny":
      return "button-xs";
    case "sm":
    case "small":
      return "button-sm";
    case "md":
    case "medium":
      return "button-md";
    case "lg":
    case "large":
      return "button-lg";
    default:
      return "";
  }
}, h = (t) => {
  switch (t) {
    case "xs":
    case "tiny":
      return 14;
    case "sm":
    case "small":
      return 14;
    case "md":
    case "medium":
      return e.small;
    case "lg":
    case "large":
      return e.small;
    default:
      return e.small;
  }
}, x = (t) => {
  switch (t) {
    case "xs":
    case "tiny":
      return e.small;
    case "sm":
    case "small":
      return e.small;
    case "md":
    case "medium":
      return e.normal;
    case "lg":
    case "large":
      return e.normal;
    default:
      return e.normal;
  }
}, g = (t, s) => t ? s ? "button-icon-square" : "button-icon-circle" : "";
function w(t) {
  return {
    fill: n.white,
    outline: n.blue,
    text: n.blue,
    outlineSubtle: n.blue,
    destructive: n.white
  }[t];
}
const S = (t) => {
  const s = d(t.variant), l = b(t.size), r = g(t.icon, t.square), a = t.square ? "button-square" : "", u = t.fullWidth ? "button-full-width" : "", c = t.forceWidth ? "force-width" : "", i = t.isLoading ? "button-loading" : "";
  return `${s} ${l} ${r} ${a} ${u} ${c} ${i}`;
};
export {
  o as NovoButtonSize,
  m as NovoButtonVariant,
  x as getButtonMainIconSize,
  h as getButtonSideIconSize,
  S as getButtonStyleClasses,
  w as getSpinnerColor
};
